export default __webpack_public_path__ + "static/portfolio-sidebar-3d73b1946a8eb3a157e7ae9e340f82d9.jpg";